import React from 'react'
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div>
      <div className='footer-box'>
          <footer>Copyright 2025 엘동부</footer>
      </div>
      <a href='/docs/opensourcelicense' className='link-opensourcelicence'>
          <footer>오픈소스 라이선스 고지</footer>
          </a>
    </div>  
  )
}

export default Footer;